import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle,DropdownItem, DropdownMenu } from 'reactstrap'
import { Link } from "react-router-dom";
import { Send, Headphones,Mail } from 'react-feather';
import { useCookies } from 'react-cookie';
import useScript from 'react-script-hook';

import qs from 'query-string';

import Logo       from "~/assets/images/logo/logo-color.svg";
import LogoHeader from "~/assets/images/login/login-logo.svg";
import Cowboy     from "~/assets/images/cowboy.png";


const ReferralProgramPage = (props)=> {

  const [loading] = useScript({src: "https://msrvt.net/et.js"});

  const [_cookies   , setCookie, _removeCookie] = useCookies();
  const [toggleDrop , setToggleDrop           ] = useState(false);

  const value = qs.parse(props.location.search);

  useEffect(()=> {
    setCookie("referral", value.ref, {
      expires : new Date(new Date().setDate(new Date().getDate() + 30)), // in 30 days
      domain: ".earndorado.com",
      path    : "/",
      sameSite: 'lax',
      secure: true,
    });
  }, []);


  if(loading) return null;

  return (
    <div className="login-card referral-program-page">
      <Card className="chat-default">
        <CardHeader className="card-no-border header">
          <div className="media media-dashboard">
            <div className="media-body">
              <img src={LogoHeader} />
              <Dropdown direction="left" toggle={()=> setToggleDrop(!toggleDrop)} isOpen={toggleDrop} className="headphones">
                <DropdownToggle tag="span"> <Headphones /> </DropdownToggle>
                <DropdownMenu tag="span">
                  <DropdownItem tag="a" href="https://www.earndorado.com#contact" target="_blank"> <Mail /> Contact </DropdownItem>
                  <DropdownItem tag="a" href="https://t.me/askearndorado" target="_blank"> <Send  /> Telegram </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </CardHeader>

        <CardBody className="chat-box">
          <div className="chat">
            <div className="media left-side-chat">
              <div className="media-body">
                <img className=" img-profile img-fluid" src={Logo}/>
                <div className="main-chat">
                  <div className="message-main">
                    <span className="mb-0"> Hey Cowboy! <br/>
                      Are you looking to have fun and be rewarded for this?
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="media right-side-chat">
              <div className="media-body">
                <div className="message-main"> <span>Hey Hey! Definitely yes!!!</span> </div>
                <img className="img-profile m-l-20 img-fluid" src={Cowboy} />
              </div>
            </div>
            <div className="media left-side-chat">
              <div className="media-body">
                <img className=" img-profile img-fluid" src={Logo}/>
                <div className="main-chat">
                  <div style={{maxWidth: 600}} className="sub-message message-main"><span>With EarnDorado you can earn points by doing different activities and exchanging them for Gift Cards, PayPal Cash, or Cryptocurrencies.</span></div>
                </div>
              </div>
            </div>

            <div className="media right-side-chat">
              <div className="media-body">
                <div className="message-main"><span>Wow! Tell me more about it!</span> </div>
                <img className="img-profile m-l-20 img-fluid" src={Cowboy} />
              </div>
            </div>
            <div className="media left-side-chat">
              <div className="media-body">
                <img className=" img-profile img-fluid" src={Logo}/>
                <div className="main-chat">
                  <div className="sub-message message-main">
                    <span>Earn points easily by doing various tasks like: <br/>
                      - Doing Daily check-ins <br/>
                      - Redeem points from Telegram giveaways <br/>
                      - Entering daily games tournaments <br/>
                      - Completing various surveys <br/>
                      - Doing micro tasks <br/>
                      - Trying new apps and games <br/>
                      - Bringing your friends to Earndorado <br/>
                      and many others ;)
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="media right-side-chat">
              <div className="media-body">
                <div className="message-main"><span>Sounds amazing! How I can get in?</span> </div>
                <img className="img-profile m-l-20 img-fluid" src={Cowboy} />
              </div>
            </div>
            <div className="media left-side-chat">
              <div className="media-body">
                <img className=" img-profile img-fluid" src={Logo}/>
                <div className="main-chat">
                  <div className="sub-message message-main"><span>That's even more! 🎁 Register now and We will give you 200 points starting bonus!</span></div>
                </div>
              </div>
            </div>

            <div className="text-center m-t-50">
              <Link to={"/login"} className=" btn btn-link register-link" data-mndet>
                <strong> <Send /> Register Now </strong>
              </Link>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  )
};

export default ReferralProgramPage;
